import React, { useRef } from 'react';
var VeltNotificationsPanelContentAllReadContainer = function (props) {
    var isAllRead = props.isAllRead, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-content-all-read-container", { ref: ref, "is-all-read": [true, false].includes(isAllRead) ? (isAllRead ? 'true' : 'false') : undefined }, children));
};
export default VeltNotificationsPanelContentAllReadContainer;
